<template>
  <div
    id="livechat_pagelist"
    class="fill-height"
    style="overflow-y: auto; border-right: 1px solid #eee"
  >
    <template v-for="(bot, bindex) in optionBotlist">
      <div
        :id="`bot_${bot.value}`"
        :key="`bot_${bindex}`"
        class="page"
        @click="selectPage(bot, bot.isLock)"
      >
        <livechat-page-badge :value="value" :bot="bot"></livechat-page-badge>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import LivechatPageBadge from './livechat-page-badge.vue'
export default {
  components: {
    LivechatPageBadge
  },
  props: ['value'],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    optionBotlist: function () {
      return this.botlist
        .map((el) => {
          var isLock = !(
            this.$store.state.livechatPageList.includes(el.theme) ||
            this.$store.state.livechatPageIdList.includes(el.pageid) ||
            (el.theme == 'ecommercebasic' && el.pageid == '270028443161479') ||
            el.isUnlockLivechat
          )
          return { ...el, name: el.pagename, value: el.pageid, isLock: isLock, theme: el.theme }
        })
        .filter((el) => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.$el.querySelector(`#bot_${newVal}`)) {
        this.$el.querySelector(`#bot_${newVal}`).scrollIntoView()
        this.$store.dispatch('forceLoadLastestUsers').then(() => {})
      }
    }
  },
  async mounted() {
    await this.$nextTick()
    if (this.$el.querySelector(`#bot_${this.value}`)) {
      this.$el.querySelector(`#bot_${this.value}`).scrollIntoView()
    }
  },
  methods: {
    async selectPage(bot, isLock) {
      if (isLock) {
        return false
      }
      this.$store.state.newchatnotify = {}
      this.$store.commit('SELECT_PAGE_LIVECHAT', bot)
      this.$emit('changePage', bot.pageid)

      const result = await this.$store.dispatch('livechatnotiunread')
      this.$store.dispatch('calculateTotalLivechatNotiUnread', {
        data: result.data || {},
        livechatChannelOptions: this.livechatChannelOptions,
        bot: {
          pageid: bot.pageid
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  .img {
    cursor: pointer;
    &.active {
      cursor: pointer;
    }

    &.islock {
      filter: grayscale(100%);
      cursor: not-allowed;
    }
  }
}
</style>

<style lang="scss">
.page .v-badge--overlap .v-badge__badge {
  top: 1px;
  right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-pagelist.vue